import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import * as actions from './../redux/actions'
import autobind from 'react-autobind'
import { Redirect } from 'react-router-dom';
import Alert from './../components/Errors/Alert'
import AlertSuccess from './../components/Success/Alert'
import { Link } from 'react-router-dom';

import logo from './../img/indexAR-logo-white.png';
import sponsor1 from './../img/sponsor1.png';
import sponsor2 from './../img/sponsor2.png';
import sponsor3 from './../img/sponsor3.png';

class ForgotPasswordResetPage extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            password: "",
            confirmPassword: "",
            token: this.props.match.params.token,
            resetSuccess: false
        };
        autobind(this)
    }

    onPassowrdChange(event) {
        this.setState({ password: event.target.value });
    }

    onConfirmPasswordChange(event) {
        this.setState({ confirmPassword: event.target.value });
    }

    onResetPasswordTokenClick(e) {
        e.preventDefault();
        const { password, confirmPassword, token } = this.state
        this.props.resetPasswordToken({
            token,
            newPassword: password,
            newPasswordConfirmation: confirmPassword
        }, () => {
            this.setState({
                resetSuccess: true
            })
        });
    }

    render() {
        const { password, confirmPassword, resetSuccess } = this.state;
        const { resetPasswordTokenError } = this.props

        if (!this.props.match.params.token) {
            return <Redirect to="/login" />
        }

        return (
            <div className="white-bg-top-wrapper">
                <div className="splash-wrapper">
                    <div className="d-flex justify-content-between flex-wrap mb-5">
                        <img src={sponsor1} width="135" height="107" alt="Sponsor" />
                        <img src={sponsor2} width="114" height="114" alt="Sponsor" />
                        <img src={sponsor3} width="127" height="120" alt="Sponsor" />
                    </div>
                    <div className="splash-container row">
                        <img src={logo} alt="logo" width="117" height="102" className="logo-img mb-4 login-logo" />
                        <div className="col-sm-6 user-message">
                            <span className="alternative-message alternative-message-register">You don't have an account? <Link to="/register">Register here!</Link></span>
                        </div>
                        <div className="col-sm-6 form-message d-flex justify-content-center">
                            <div>
                                <span className="splash-description text-center mt-5 mb-5">
                                    Reset your password.
                                    </span>
                                {resetPasswordTokenError ? <Alert message={resetPasswordTokenError} /> : null}
                                {resetSuccess ? <AlertSuccess message="Your password has been reset. Please go back to login by clicking here." path="/login" /> : null}
                                <form>
                                    <div className="form-group">
                                        <div className="input-group"><span className="input-group-addon"><i className="icon s7-lock"></i></span>
                                            <input type="password" placeholder="New password" autoComplete="off" className="form-control"
                                                onChange={this.onPassowrdChange}
                                                value={password} />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-group"><span className="input-group-addon"><i className="icon s7-lock"></i></span>
                                            <input type="password" placeholder="Confirm password" autoComplete="off" className="form-control"
                                                onChange={this.onConfirmPasswordChange}
                                                value={confirmPassword} />
                                        </div>
                                    </div>
                                    <div className="form-group login-submit">
                                        <button data-dismiss="modal" type="submit" className="btn btn-lg btn-primary btn-block" onClick={this.onResetPasswordTokenClick}>
                                            Reset password
                                    </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="text-center mt-px-100">
                        <p className="mb-2 disclaimer-text">Pentru informaţii detaliate despre celelalte programe cofinanţate de Uniunea Europeană, vă invităm să vizitaţi <a href="http://www.fonduri-ue.ro">www.fonduri-ue.ro</a></p>
                        <p className="text-xs">Conţinutul acestui material nu reprezintă în mod obligatoriu poziţia oficială a Uniunii Europene sau a Guvernului României</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const { auth: { resetPasswordTokenError, user } } = state
        return { ...ownProps, resetPasswordTokenError, user }
    },
    actions,
    (stateProps, dispatchProps) => {
        return Object.assign({}, stateProps, dispatchProps, { alertSomething: (text) => { alert(text) } })
    }
)(ForgotPasswordResetPage)



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordReset.js